import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { customRedirectCookieName } from "../hooks/useSsoRedirect";
import LoadingPage from "./LoadingPage";
import { NotFoundPage } from "../pages";
import { isRootDeadEndPath } from "../pages/NotFoundPage/notFoundRedirect";
import { getCookie } from "../utils/getCookie";
import { syncBeverageUserSessionForAcid } from "../utils/beverageSession";
import { getExperienceParams } from "../utils/experienceContext";

export default function TryAuth() {
  const navigate = useNavigate();
  const location = useLocation();
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get("code");
  const state = urlParams.get("state");
  const [hasAuthCode, setHasAuthCode] = useState(!!code);

  useEffect(() => {
    if (!hasAuthCode) {
      return;
    }

    const newUrl = `${window.location.pathname}`;
    window.history.replaceState(null, "", newUrl);

    const getToken = async () => {
      const tokenResponse = await fetch(
        "/api/v1/web/marriott-passions-v3/token",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
            body: JSON.stringify({ code, state, ...getExperienceParams() }),
        },
      );

      if (!tokenResponse.ok) {
        setHasAuthCode(false);
        return;
      }

      const body = await tokenResponse.json();
      const { acid, access_token } = body || {};

      if (!acid) {
        setHasAuthCode(false);
        return;
      }

      // store access token for save-consent usage
      if (access_token) {
        sessionStorage.setItem("access_token", access_token);
      } else {
        console.warn("Token response did not include access_token.");
      }

      const campaign = getCookie("passions_campaign");
      const jumpToResult = getCookie("jtr");
      const customRedirectUrl = getCookie(customRedirectCookieName);

      // Check for custom redirect URL first (e.g., from consent flow)
      if (customRedirectUrl) {
        syncBeverageUserSessionForAcid(acid);
        sessionStorage.setItem("acid", acid);
        navigate(customRedirectUrl);
        return;
      }

      if (!campaign) {
        navigate(`/campaign?acid=${acid}`);
        return;
      }

      if (jumpToResult) {
        syncBeverageUserSessionForAcid(acid);
        sessionStorage.setItem("acid", acid);
      }

      const page = jumpToResult
        ? new URLSearchParams(campaign).get("expId") + "/explore"
        : `/campaign?acid=${acid}&${campaign}`;

      navigate(page);
    };

    getToken();
  }, []);

  if (hasAuthCode) {
    return <LoadingPage />;
  }

  return <NotFoundPage autoRedirect={isRootDeadEndPath(location.pathname)} />;
}
